import { useMutation } from 'react-apollo';
import { cloneDeep } from 'lodash';
import { DataProxy } from 'apollo-cache';
import { orderListQuery } from 'queries/OrderList';
import {
  ArchiveStockMutation as Mutation,
  ArchiveStockMutationVariables as Variables,
} from './__generated__/ArchiveStockMutation';
import * as mutation from './mutation.gql';
import { OrderListQuery } from 'queries/OrderList/__generated__/OrderListQuery';

const updateLabOrderList = (orderId: number) => (store: DataProxy) => {
  const query = orderListQuery({ archived: false });
  const data = store.readQuery<OrderListQuery>(query);
  if (!data) {
    return;
  }

  const newData = cloneDeep(data);

  newData.lab.buyOrders.list = data.lab.buyOrders.list.filter(
    (order) => !(order.__typename === 'Stocks_BuyOrder' && order.id === orderId)
  );

  store.writeQuery<OrderListQuery>({ ...query, data: newData });
};

export const useArchiveMutation = (id: number) => {
  const [archive, { loading, error }] = useMutation<Mutation, Variables>(mutation, {
    variables: { id },
    refetchQueries: [orderListQuery({ archived: true })],
    update: updateLabOrderList(id),
  });

  return {
    archive: () => archive(),
    loading,
    error,
  };
};
